module.exports = __webpack_public_path__ + "img/opioid_pills_updated.237df3f1.png";